import { useCallback, useState } from "react";
import LogoMini from "../../../components/icons/LogoMini";
import PlayTriangle from "../../../components/icons/PlayTriangle";
import "../general.scss";
import "./index.scss";
import Popup from "../../../components/Popup";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import GuestApp from "../../../assets/img/SolutionsIcons/AgilysysGuest.svg";
import { Header } from "../../../components/Header";

const GuestAppFPage = () => {
    const [showVideo, setShowVideo] = useState<boolean>(false);
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    return(
        <div className="page splash guestAppFPage">
            <div className="page-title"><img src={GuestApp} alt="" /></div>
            <Header />
            <div className="text-blocks">
                <div className="std-text">
                Wrap your brand around a downloadable app that provides
a frictionless guest experience from booking to check-out.
Available in both the Android and iOS app stores, the
Agilysys Guest App helps you showcase your property and 
drive revenue.{'\n\n'}
                </div>
                <div className="std-text">
                This simple mobile app allows guests to book rooms, golf
and spa; check-in; use digital room keys; and check-out all
from an app with your brand and property data.
                </div>
            </div>
            <div className="play-video" onClick={()=>{
                _logEvent('click', "Solutions - Guest App", "Play Video");
                addFlow("Play Video");
                setShowVideo(true)}}>
                <PlayTriangle />
                Play Video
            </div>
            <img className="img-1" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/guestApp1.png"} alt="" />
            <img className="img-2" src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/guestApp2.png"} alt="" />
            <Popup showPopup={showVideo} setShowPopup={()=>setShowVideo(false)} disableOffClick={true}>
                <>{showVideo && <video 
                autoPlay
                controls
                src={"https://storage.googleapis.com/popshap-kiosks-dev.appspot.com/agilysys/FeaturedSolutions/videos/InteractiveGuestApp2.mp4"} />}</>
            </Popup>
        </div>
    )
}

export default GuestAppFPage;